import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Grid,
  Flex,
  Text,
  Input,
  useToast,
} from '@chakra-ui/react'
import { Button } from '../../../../../../components/Button'
import { useState } from 'react'
import { api } from '../../../../../../services/api'
import { useMutation, useQuery } from 'react-query'
import { formatPrice } from '../../../../../../utils/formatPrice'

async function getQuantitys({ codprod, codImp, codColor, batidas, entrega }) {
  const params = {
    codprod,
    codImp,
    codColor,
    batidas,
    entrega,
  }

  const res = await api.get(`produto/buscar-valor-quantidades-produto/${codprod}/${codImp}/${codColor}/${batidas}/${entrega}`)

  return res.data
}

export function Multiplo({ item, cor, impressao, prazo, personalizacao, setValue, atualizar }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [quantitySelected, setQuantitySelected] = useState(null)
  const [inputQuantity, setInputQuantity] = useState(0)

  const { mutateAsync, data = [] } = useMutation({
    mutationFn: () =>
      getQuantitys({
        codprod: item.codigo_produto,
        codImp: personalizacao,
        codColor: cor.codigo_cor,
        batidas: impressao,
        entrega: prazo,
      }),
  })

  async function handleOpen() {
    await mutateAsync()
    onOpen()
  }

  function handleClose() {
    onClose()
  }

  const toast = useToast({
    position: 'top',
    isClosable: true,
    duration: 5000,
  })

  async function onConfirm() {
    if (inputQuantity !== 0) {
      if (inputQuantity % item.multiplo !== 0) {
        return toast({
          title: 'Quantidade inválida',
          description: `A quantidade deve ser múltipla de ${item.multiplo}`,
          status: 'error',
        })
      }

      //nao deixa ',' e '.'
      if (inputQuantity.toString().includes(',') || inputQuantity.toString().includes('.')) {
        return toast({
          title: 'Quantidade inválida',
          description: 'A quantidade não pode conter vírgula ou ponto',
          status: 'error',
        })
      }

      setValue('quantidade', inputQuantity)
    }

    await atualizar()
    onClose()
  }

  function handleQuantityInput(event) {
    setQuantitySelected(null)

    const value = event.target.value

    setInputQuantity(value)
  }

  function handleSelectQuantity(quantity) {
    setQuantitySelected(quantity)

    setValue('quantidade', String(quantity))
  }

  return (
    <>
      <Button bgColor="#0075B1" h="29px" borderRadius="0" size="xs" onClick={handleOpen}>
        Atualizar
      </Button>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Este produto é multiplo de {item.multiplo}.</ModalHeader>
          <ModalCloseButton />
          <ModalBody display="flex" flexDir="column" gap={3}>
            <Text>Selecione a quantidade desejada</Text>
            <Grid templateColumns="repeat(3, 1fr)" gap={2}>
              {data.map((item) => (
                <Button
                  key={item.quantity}
                  onClick={() => handleSelectQuantity(item.quantity)}
                  bgColor={quantitySelected === item.quantity ? 'green.500' : 'blue.500'}
                >
                  <Flex flexDir="column">
                    <Text as="strong">{item.quantity} unidades</Text>

                    <Text as="span">{formatPrice(item.value)}</Text>
                  </Flex>
                </Button>
              ))}
            </Grid>

            <Text>Ou digite a quantidade multipla de {item.multiplo}</Text>

            <Flex flexDir={'column'} gap={2}>
              <Input type="number" placeholder="Digite a quantidade" onChange={handleQuantityInput} />
            </Flex>
          </ModalBody>

          <ModalFooter>
            <Button bgColor="red.500" colorScheme="blue" mr={3} onClick={handleClose}>
              Fechar
            </Button>
            <Button onClick={onConfirm} bgColor="green.500" variant="ghost">
              Atualizar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
